<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>{{ 'reports.query-tool.save-query.save-this-query' | translate | titlecase }}</h4>
  </ng-template>

  <form #crudForm="ngForm" class="atlas-form">
    <div class="mct-flex mct-col mct-gap-27" *ngIf="dataQueryDto">
      <div>
        <label class="light-text">{{ 'common.name' | translate | ucfirst }}</label>
        <input [(ngModel)]="dataQueryDto.Name" name="name" required />
      </div>
      <div class="mct-flex mct-col">
        <label class="light-text">{{ 'common.description' | translate | ucfirst }}</label>
        <textarea name="descr" pInputTextarea [(ngModel)]="dataQueryDto.Descr"></textarea>
      </div>
      <div>
        <label class="light-text">{{ 'reports.query-tool.save-query.assignee' | translate | ucfirst }}</label>
        <p-select
          ngDefaultControl
          appendTo="body"
          name="assignee"
          [(ngModel)]="dataQueryDto.UserNum"
          [options]="activeUsers"
          showClear
          [placeholder]="'reports.query-tool.save-query.assignee-placeholder' | translate | titlecase"
          [style]="{ width: '100%' }"
        ></p-select>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!crudForm.valid" (click)="checkForDuplicateDataQuery()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>

<p-confirmDialog
  #cd
  key="queryOverWriteCD"
  header="{{ 'reports.query-tool.save-query.overwrite-query-title' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()">
      {{ 'common.yes' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
